import repoUrls from 'src/sections/repository/urls';

import { MavenVersionResponse } from '../../types';
import { buildPackagesApiQueryString } from '../../utils';
import { packagesResourceFactory } from '../utils';

export const packagesMavenVersionResource =
  packagesResourceFactory<MavenVersionResponse>()({
    key: 'packages-maven-version',
    pathParamNames: [
      'packageName',
      'mavenBaseVersion',
      'mavenVersion',
    ] as const,
    queryParamNames: [] as const,
    getRequestUrl: (context, pathParams, _queryParams) => {
      const queryString = buildPackagesApiQueryString({
        packageName: pathParams.packageName,
        baseVersion: pathParams.mavenBaseVersion,
        version: pathParams.mavenVersion,
      });

      switch (context.container) {
        case 'repository':
          return repoUrls.api.internal.mavenVersion(
            context.workspaceSlug,
            context.repositorySlug,
            queryString
          );
        default:
          throw new Error('Invalid route context');
      }
    },
  });
